import queryString from "query-string";
import validDomains from "../constants/validDomainList";
import cdaTracker from "./loadCdaTracker";

const VALID_DOMAINS = validDomains || [];
let cdaTrackerStarted = false;

const findDomain = () => {
  const values = queryString.parse(window.location.search.toLocaleLowerCase());
  return values.domain;
};

const sendHeightToParent = () => {
  const height = document.body.scrollHeight;
  const domain = findDomain();
  if (VALID_DOMAINS.includes(domain)) {
    window.parent.postMessage({ height }, "*");
  }
  // Start CDA tracker only once
  if (!cdaTrackerStarted) {
    cdaTracker.start();
    cdaTrackerStarted = true;
  }
};

const postScrollHeightToParent = () => {
  sendHeightToParent();
  // Wait for fonts to load to get accurate height
  if ('fonts' in document) {
    document.fonts.ready.then(() => {
      setTimeout(() => {
        sendHeightToParent();
      }, 100);
    });
  } else {
    setTimeout(() => {
      sendHeightToParent();
    }, 1000);
  }
};

const postUrlToParent = (videoUrl) => {
  const domain = findDomain();
  if (VALID_DOMAINS.includes(domain)) {
    window.parent.postMessage({ videoUrl }, "*");
  }
};

export { postScrollHeightToParent, postUrlToParent };
